import { FinanceSettingsOrganization } from '../domain/groupLineItemsByOrganization.ts';

type FormOrganization<TOrganization> = TOrganization & {
    offset: number;
};

export function addOrganizationsOffsets<T extends FinanceSettingsOrganization>(
    organizations: T[]
): FormOrganization<T>[] {
    const result: FormOrganization<T>[] = [];
    let offset = 0;

    for (const organization of organizations) {
        result.push({ ...organization, offset });
        offset += organization.financeSettings.length;
    }

    return result;
}
